import * as Yup from 'yup'

export const ChangePasswordSchema = Yup.object().shape({
	newPassword: Yup.string().required('Debes ingresar una contraseña'),
	confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Las contraseñas no son iguales'),
})
